module.exports = __webpack_public_path__ + "img/draft.0ef4352e.svg";